// extracted by mini-css-extract-plugin
export var content = "about-module--content--e112b";
export var graphic = "about-module--graphic--53165";
export var inner = "about-module--inner--0320d";